export default {
    init() {
        $('#search-area').each(function() {
            $(this)
                .on('keyup', 'input', function() {
                    const $this = $(this);
                    filter($this);
                })
                .on('change', 'select', function() {
                    const $this = $(this);
                    filter($this);
                });
        });

        $('#js-pagination').each(function() {
            $(this).on('click', 'a', function(e) {
                e.preventDefault();
                const page = $(this).data('page');
                console.log(page);
                $('#js-form-filter').find('[name=my_page]').val(page);
                setTimeout(function() {
                    $('#js-form-filter').find('[type=submit]').trigger('click')
                },200);
            });
        });
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
  };
  


  function filter($this) {
    var value = $this.val().toLowerCase();
    console.log(value);
    if(value === 'all' || value === '') {
        $("#results .col").hide();
    } else {
        $("#results .col").filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
        });
    }
  }


// WEBPACK FOOTER //
// ./scripts/routes/templateBiblioonte.js